/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ReactNode, useCallback } from 'react';
import { ErrorFlagRenderer } from '@jira/platform__error-flag-renderer/src/ErrorBoundaryFlag.tsx';
import ErrorBoundary, {
	type ExtraErrorAttributes,
} from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

export type ModalBoundaryProps = {
	children: ReactNode;
	id: string;
	metricKey?: string;
	packageName: string;
	teamName?: string;
	onError?: (location: string, error: Error, attributes: ExtraErrorAttributes) => void;
};

export const ModalBoundary = ({
	children,
	id,
	metricKey,
	packageName,
	teamName,
	onError,
}: ModalBoundaryProps): React.JSX.Element => {
	const renderErrorState = useCallback(
		(args: { error: Error }) => (
			<ErrorFlagRenderer id={id} error={args.error} packageName={packageName} teamName={teamName} />
		),
		[id, packageName, teamName],
	);
	const fallback =
		typeof metricKey === 'string' && metricKey.length > 0 ? (
			<PerformanceMark metricKey={metricKey} />
		) : (
			<></>
		);

	return (
		<ErrorBoundary
			id={id}
			packageName={packageName}
			teamName={teamName}
			render={renderErrorState}
			onError={onError}
		>
			<Placeholder name={id} fallback={fallback}>
				{children}
			</Placeholder>
		</ErrorBoundary>
	);
};
